import { Component, OnInit } from '@angular/core';
import { NgForm} from '@angular/forms';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {environment as env} from '../../../environments/environment';
import {SiteuserService} from '../../services/siteuser.service';
import {LanguageService} from '../../services/language.service';

@Component({
  selector: 'app-editprofile',
  templateUrl: './editprofile.component.html',
  styleUrls: ['./editprofile.component.css']
})
export class EditprofileComponent implements OnInit {
  isError:boolean;
  errmsg:string;
  isSuccess:boolean;
  sucMsg:string = '';
  isLoading:boolean;

  uname:string;
  sajid:string;
  userdata:any[] = [];
  uMobile:string;
  showLang:string;

  constructor(private router:Router, private http:HttpClient,
     private usrObj:SiteuserService,private langObj:LanguageService) {
    this.langObj.langStr.subscribe((data)=>{
      this.showLang = data;
    });
  }

  ngOnInit(): void {

    this.showLang = localStorage.getItem("showLang");
    if(this.showLang == null && this.showLang == undefined){
     this.showLang = 'en';
    }

    this.uname = localStorage.getItem('sajuname');
    this.sajid = localStorage.getItem('sajid');
    this.http.get(env.apiurl+'get-user-by-id/'+this.sajid).subscribe(data=>{
      this.userdata = data['data'];
      this.uMobile = data['data']['uPhone'].substring(4);

    });

  }

  onProfileUpdateSubmit(profForm:NgForm){ 
    // console.log(profForm.value);
    this.isLoading=true;
    this.http.post(env.apiurl+'update-profile', {
      
      UserID:this.usrObj.getLoggedinId(),
      UserName:profForm.value.username,
      UserEmail:profForm.value.email,
      UserPhone:'+971'+profForm.value.userphone.replace(/^0+/, ''),
      UserPassword:profForm.value.password,
    }).subscribe(rawData=>{
      this.isLoading = false;
      // console.log(rawData);
      if (rawData['success'] == true){
        this.isError = false;
        this.isSuccess = true;
        this.sucMsg = rawData['message'];
        this.router.navigate(['my-account']); 
      }else{
        this.isError = true;
        this.isSuccess = false;
        this.errmsg = rawData['data'];
      }
    });
  }

  logout(){
    localStorage.removeItem('sajid');
    localStorage.removeItem('sajuname');
    localStorage.removeItem('sajtoken');
    this.router.navigate(['order-online']); 
  }

}